module.exports = __webpack_public_path__ + "static/media/large-saxenda-green.e5686edd.png";